import "@example/Store/Reducers";
import { addWidgetsFromContext } from "@insite/client-framework/Configuration"; // Importing nothing to trigger the side effects, which in this case adds custom reducers.
import { setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import "@rightstore/Handlers/DisplayProductHandler";
import "@rightstore/Handlers/DisplayProductsHandler";
import "@rightstore/Handlers/LoadDataIfNeededHandler";
import "@rightstore/Handlers/LoadOrdersHandler";
import "@rightstore/Handlers/LoadProductByPathHandler";
import "@rightstore/Handlers/LoadProductsHandler";
import "@rightstore/Handlers/LoadVariantChildrenHandler"
import "@rightstore/Store/Data/AllProducts/AllProductsReducer";
import "@rightstore/Store/Data/BudgetBalance/BudgetBalanceReducer";
import "@rightstore/Store/Data/InitialLoadReducer";
import { css } from "styled-components";

// load all widgets. Without this they won't be included in the bundle
const widgets = IS_PRODUCTION
    ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
    : require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

if (!IS_PRODUCTION) {
    // load all widget extensions. They could be loaded individually instead
    const widgetExtensions = require.context("./WidgetExtensions", true);
    widgetExtensions.keys().forEach(key => widgetExtensions(key));
}

// add some post styleguide customizations. These can't be overridden by the style guide
setPreStyleGuideTheme({
    globalStyle: {
        css: css`
            body {
                overflow-x: hidden;
                min-height: 100vh;              
            }
            
            .intercom-lightweight-app-launcher {
                display: none;
            }
        }       
        `
    },
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 480, 1200, 1440, 1920],
        maxWidths: [540, 720, 960, 1300, 1460],
    },
    colors: {
        primary: {
            main: "#003745",
        },
        secondary: {
            main: "#F7661F",
        },
        common: {
            background: "#FFFFFF",
            backgroundContrast: "#003745",
            accent: "#F8F9FA",
            accentContrast: "#003745",
            border: "#B3B3B3",
            disabled: "#D9D9D9",
        },
        text: {
            main: "#333333",
            disabled: "#D9D9D9",
            accent: "#F7661F",
            link: "#003745",
        },
        success: {
            main: "#008561",
        },
        danger: {
            main: "#E61E2F",
        },
        warning: {
            main: "#FFDD15",
        },
        info: {
            main: "#006FF8",
        },
    },
    shadows: {
        1: "0px 5.5px 35px -3px rgba(0, 55, 68, 0.1)",
    },
    button: {
        primary: {
            typographyProps: {
                color: "#ffffff",
                size: '1rem',
                weight: 700,
                lineHeight: 1.6,
            },
            activeMode: "none",
            css: css`
            outline: none;
            background: #006FF8;
            border: 1px solid #006FF8;
            border-radius: 6px;
            padding: 12px 32px;
            line-height: 0;
            &:active {
                outline: none;
            }
            &:focus {
                outline: none;
            }
            &:not([disabled]):hover {
                background: #FFFFFF;
                border: 1px solid #006FF8;
                color: #006FF8;
            }
            &:not([disabled]):hover span {
                color: #006FF8;
            }
            `,
        },
        secondary: {
            typographyProps: {
                size: '1rem',
                weight: 700,
                lineHeight: 1.6,
                css: css`
                    color: #006FF8;
                    &:disabled {
                        color: #D9D9D9 !important;
                    }
                `
            },
            activeMode: "none",
            css: css`
                outline: none;
                background: #FFFFFF;
                border: 1px solid #006FF8;
                border-radius: 6px;
                padding: 12px 32px;
                line-height: 0;
                &:active {
                    outline: none;
                }
                &:focus {
                    outline: none;
                }
                &:not([disabled]):hover {
                    background: #006FF8;
                    border: 1px solid #FFFFFF !important;
                    color: #FFFFFF;
                }
                &:not([disabled]):hover span {
                    color: #FFFFFF;
                }
            `,
        },
    },
    focus: {
        color: "transparent", // no blue borders on link focus
    },
    link: {
        defaultProps: {
            color: "#003745",
            typographyProps: {
                size: '1rem',
                weight: 700,
            },
            hoverStyle: {
                color: '#F7661F',
            },
        },
    },
    pagination: {
        defaultProps: {
            buttonProps: {
                variant: "secondary",
                hoverMode: "none",
                css: css`
                    outline: none;
                    background: transparent !important;
                    color: #006FF8;
                    border: none;
                    padding: 0;
                    width: inherit !important;
                    height: 24px;
                    align-items: center;
                    display:flex;
                    > span {
                        font-size: 1rem;
                        line-height: 24px;
                        font-weight:400;
                        margin: 0 12px;
                    }
                    &:not(:disabled) {
                        svg {
                            color: #006FF8;
                        }
                    }
                    :not(:disabled):hover{
                        color: #006FF8;
                        }
                    }
                    &:active {
                        outline: none;
                    }
                    &:focus {
                        outline: none;
                    }
                `
            },
            cssOverrides: {
                linkList: css`                      
                `,
                pagination: css`
                    justify-content: center;
                    align-items: center;
                    ul {
                        display: flex;
                        align-items: center;
                    }
                `,
                currentButton: css`          
                    background: #F2F2F2 !important;
                    border-radius: 50%;
                    padding: 0px 8px;
                    min-height: auto;
                    > span {
                        font-size: 1rem;
                        line-height: 24px;
                        font-weight:700;
                        color: #003745 !important;
                        margin: 0;
                    }
                    
                `,
            }
        }
    },
    breadcrumbs: {
        defaultProps: {
            css: css`
                position:absolute;
                top: 160px;
                z-index: 5;
                a {
                    > span {
                        color: #006FF8 !important;
                        &:hover{
                            color: #006FF8 !important;
                        }
                    }
                    :after {
                        color: #333333;
                        content: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDggMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS41ODU3OSA3TDAuMjkyODkzIDEyLjI5MjlDLTAuMDk3NjMxMSAxMi42ODM0IC0wLjA5NzYzMTEgMTMuMzE2NiAwLjI5Mjg5MyAxMy43MDcxQzAuNjgzNDE4IDE0LjA5NzYgMS4zMTY1OCAxNC4wOTc2IDEuNzA3MTEgMTMuNzA3MUw3LjcwNzExIDcuNzA3MTFDOC4wOTc2MyA3LjMxNjU4IDguMDk3NjMgNi42ODM0MiA3LjcwNzExIDYuMjkyODlMMS43MDcxMSAwLjI5Mjg5M0MxLjMxNjU4IC0wLjA5NzYzMTEgMC42ODM0MTggLTAuMDk3NjMxMSAwLjI5Mjg5MyAwLjI5Mjg5M0MtMC4wOTc2MzExIDAuNjgzNDE4IC0wLjA5NzYzMTEgMS4zMTY1OCAwLjI5Mjg5MyAxLjcwNzExTDUuNTg1NzkgN1oiIGZpbGw9IiM2NjY2NjYiLz4KPC9zdmc+Cg==");
                        background-size: 14px 8px;
                        padding:8px;
                    }
                    + span {
                        display: none;
                    } 
                }        
            `,
            typographyProps: {
                color: "#333333",
                size: '1rem',
                weight: 700,
                lineHeight: '24px',
            }

        },
    },
    checkbox: {
        defaultProps: {
            color: '#006FF8',
            typographyProps: {
                size: 16,
                lineHeight: 1.5,
            },
            css: css`
            span[role=checkbox]{
                border: 1px solid #B3B3B3;
            }
            span[role=checkbox][aria-disabled="true"]{
                border: 1px solid #B3B3B3;
            }
            span[role=checkbox]:focus {
                    outline: none;
                    box-shadow:none;
                    border:2px solid #006FF8;
                }
            span[role=checkbox][aria-checked="true"]:focus {
                    box-shadow: none;
                }
            span[role=checkbox][aria-checked="mixed"]:not([aria-disabled="true"]){
                background: #006FF8;
            }
        `
        }
    },
    radio: {
        defaultProps: {
            color: '#006FF8',
            css: css`
            > input + label::before {
                border: 1px solid #B3B3B3;
            }
            > input:checked:disabled + label::after {
                background: #ECEDEF;
            }
            > input:focus + label::before {
                outline: none;
                border: none;
                box-shadow: 0 0 0 2px #006FF8;
            }
        `
        }
    },
    formField: {
        defaultProps: {
            cssOverrides: {
                inputSelect: css`
                        color: #666666;
                        background: #FFFFFF;
                        border: double 2px transparent;
                        border-radius: 8px;
                        background-image: linear-gradient(white, white), 
                        linear-gradient(90.55deg, rgba(247, 102, 31, 0.42) -1.07%, rgba(247, 102, 31, 0.31) 9.45%, rgba(212, 103, 62, 0.295908) 16.3%, rgba(135, 149, 197, 0.31) 36.3%, rgba(73, 130, 216, 0.227073) 46.83%, rgba(0, 111, 248, 0.23) 57.36%, rgba(0, 95, 197, 0.267348) 65.26%, rgba(0, 76, 135, 0.312179) 78.42%, rgba(0, 55, 69, 0.36) 87.89%, rgba(0, 55, 69, 0.36) 99.73%);
                        background-origin: border-box;
                        background-clip: padding-box, border-box;
                        height: 48px;
                        &:focus {
                            border: 1px solid #006FF8;
                            border-radius: 8px;
                        }
                        &#error-text {
                            border-radius: 8px;
                        }
                        &#error-text:focus {
                            border: 1px solid #006FF8;
                            border-radius: 8px;
                        }
                    `,
            },
        },
    },
    textArea: {
        defaultProps: {
            css: css`
            border-radius: 8px !important;
            border: double 2px transparent !important;
            background-image: linear-gradient(white, white), 
            linear-gradient(90.55deg, rgba(247, 102, 31, 0.42) -1.07%, rgba(247, 102, 31, 0.31) 9.45%, rgba(212, 103, 62, 0.295908) 16.3%, rgba(135, 149, 197, 0.31) 36.3%, rgba(73, 130, 216, 0.227073) 46.83%, rgba(0, 111, 248, 0.23) 57.36%, rgba(0, 95, 197, 0.267348) 65.26%, rgba(0, 76, 135, 0.312179) 78.42%, rgba(0, 55, 69, 0.36) 87.89%, rgba(0, 55, 69, 0.36) 99.73%) !important;
            background-origin: border-box !important;
            background-clip: padding-box, border-box !important;
            &:focus {
                border: 1px solid #006FF8 !important;
            }       
            `
        },
    },
    typography: {
        fontFamilyImportUrl: "https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap",
        body: {
            size: '16px',
            weight: 400,
            fontFamily: "'Roboto', sans-serif",
        },
        p: {
            size: '1rem',
            weight: 400,
            lineHeight: '32px',
        },
        h1: {
            size: '3.5rem',
            weight: 400,
            lineHeight: '84px',
            color: "#003745",

            css: css`            
            ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                        line-height: 64px;
                    `,
                        css`
                        line-height: 64px;
                    `,
                        null,
                        null,
                        null,
                    ]);
                }}                                  
            `,
        },
        h2: {
            size: '3rem',
            weight: 400,
            lineHeight: '72px',
            color: "#003745",

            css: css`            
            ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                        line-height: 42px;
                    `,
                        css`
                        line-height: 42px;
                    `,
                        null,
                        null,
                        null,
                    ]);
                }}                                                                     
            `,

        },
        h3: {
            size: '2.5rem',
            weight: 700,
            lineHeight: '60px',
            color: "#003745",

            css: css`            
            ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                        line-height: 36px;
                    `,
                        css`
                        line-height: 36px;
                    `,
                        null,
                        null,
                        null,
                    ]);
                }}                                  

            `,
        },
        h4: {
            size: '1.75',
            weight: 700,
            lineHeight: 1.57,
            color: "#003745",
        },
        headerPrimary: {
            size: '2.5rem',
            weight: 700,
            lineHeight: '32px',
            color: "#003745",
            fontFamily: "'Roboto', sans-serif",
        },
        headerSecondary: {
            size: '1.125rem',
            weight: 500,
            lineHeight: 1.56,
            transform: 'capitalize',
            fontFamily: "'Roboto', sans-serif",
            color: "#003745"
        },
        headerTertiary: {
            size: '1.25rem',
            weight: 400,
            transform: 'none',
            fontFamily: "'Roboto', sans-serif",
            color: "#666666"
        },
    },
});

